/**
 * Presets Registry
 * Central registry for component preset configurations
 * Individual components will extend these base presets
 */

import type { PresetConfig } from './theme.types';

/**
 * Base preset interface that all component presets extend
 */
export interface BasePresetConfig extends PresetConfig {
  opacity?: number;
}

/**
 * Preset registry type
 * Maps preset enum values to their configurations
 */
export type PresetRegistry<T extends string, C extends BasePresetConfig> = Record<T, C>;

/**
 * Helper to create a preset registry with type safety
 */
export function createPresetRegistry<T extends string, C extends BasePresetConfig>(
  presets: PresetRegistry<T, C>
): PresetRegistry<T, C> {
  return presets;
}

